module.exports = "/_next/static/public/images/42402cf80da3039e4feec9a9d40ff65f-4aa4a91258f39971212de23b70fac096.png";